import { configureStore, Action, ThunkAction } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import rootReducer, { RootState } from "./root.reducer";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { setupListeners } from "@reduxjs/toolkit/query";
import { airportSearchApi } from "./services/airportSearch";
import { flightSearchApi } from "./services/flightSearch";
import { translationsApi } from "./services/translations";

import { countryListApi } from "./services/countryList";
import { configApi } from "./services/config";
import { airlinesSearchApi } from "./services/airlinesSearch";
import { confirmApi } from "./services/confirm";
import { revalidateApi } from "./services/revalidate";
import { bookingApi } from "./services/booking";
import { iataLookupApi } from "./services/iataLookup";
import { cancelPaymentApi } from "./services/cancelPayment";
const persistConfig = {
  key: "root",
  storage,
  // TODO: REMOVE BEFORE PRODUCTION
  blacklist: [
    // "checkout",
    // "contactInformation",
    // "travelerInformation",
    // "shoppingCart",
    // "selectedItinerary",
    // "additionalProducts",
    airlinesSearchApi.reducerPath,
    countryListApi.reducerPath,
    bookingApi.reducerPath,
    cancelPaymentApi.reducerPath,
    confirmApi.reducerPath,
    flightSearchApi.reducerPath,
    translationsApi.reducerPath,
    configApi.reducerPath,
    airportSearchApi.reducerPath,
    iataLookupApi.reducerPath,
  ],
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    })
      .concat(countryListApi.middleware)
      .concat(bookingApi.middleware)
      .concat(cancelPaymentApi.middleware)
      .concat(confirmApi.middleware)
      .concat(flightSearchApi.middleware)
      .concat(airlinesSearchApi.middleware)
      .concat(configApi.middleware)
      .concat(translationsApi.middleware)
      .concat(revalidateApi.middleware)
      .concat(airportSearchApi.middleware)
      .concat(iataLookupApi.middleware),
  devTools: process.env.NODE_ENV !== "production",
});

export type AppDispatch = typeof store.dispatch;
export type AppThunk = ThunkAction<void, RootState, null, Action<string>>;

export const UseAppDispatch = () => useDispatch<AppDispatch | any>();
setupListeners(store.dispatch);
export default store;
